
import { RulesController } from '../rulesController';
import '../directives/rulesDialog/controllers/ruleDialogController';
import '../../../core/directives/readOnlyText/readOnlyTextDirective';

export class RulesDirective implements angular.IDirective {
    template = require('../../rules/rules.html');
    controller = RulesController;
    controllerAs = "vm";
    bindToController = {
        isNewRule: '=',
        editIndex: "="
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new RulesDirective();
    }
}

angular.module('deliveryCreate.app').directive('rules', RulesDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/directives/rulesDirective.ts
 **/